import React from "react";
import { PanelAddCategory } from "../../../UI/Categories/Add/PanelAddCategory";

const AddCategory = () => {
  return (
    <div>
      <PanelAddCategory />
    </div>
  );
};

export default AddCategory;
